import { useTranslation } from 'react-i18next';
import { isClinicSelected, toggleClinicSelection } from '@/application/assistants/clinicIds';

interface ClinicsPickerProps {
  /** Clínicas disponibles (scope del dueño: `allowedTenantIds`). */
  clinics: string[];
  selected: string[];
  onChange: (clinicaIds: string[]) => void;
  disabled?: boolean;
  idPrefix: string;
  /** Resuelve el nombre visible de una clínica (por defecto muestra el id). */
  nameFor?: (clinicId: string) => string;
}

/** Selector de clínicas por checkboxes. Muestra el nombre de la clínica (o el id si no resuelve). */
export function ClinicsPicker({ clinics, selected, onChange, disabled, idPrefix, nameFor }: ClinicsPickerProps) {
  const { t } = useTranslation();

  if (clinics.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">{t('assistants.clinics.noClinics')}</p>;
  }

  const toggle = (clinicId: string) => {
    onChange(toggleClinicSelection(selected, clinicId));
  };

  return (
    <ul className="space-y-1">
      {clinics.map((clinicId) => {
        const inputId = `${idPrefix}-${clinicId}`;
        return (
          <li key={clinicId} className="flex items-center gap-2">
            <input
              id={inputId}
              type="checkbox"
              checked={isClinicSelected(selected, clinicId)}
              onChange={() => toggle(clinicId)}
              disabled={disabled}
              className="h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500"
            />
            <label htmlFor={inputId} className="truncate text-sm text-gray-700 dark:text-gray-300">
              {nameFor ? nameFor(clinicId) : clinicId}
            </label>
          </li>
        );
      })}
    </ul>
  );
}
